import React, { ChangeEvent, useState } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography, FormControl, MenuItem, InputAdornment, IconButton, Checkbox } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KenButton from '../../../../GlobalComponents/KenButton';
import { AcademicRecords } from '../../../../interfaces/Profile';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';
import { postAcademicRecords } from '../../../../Utils/apiService';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '576px', xl: '576px' },
  p: 4,
  maxHeight: '70vh',
  overflowY: 'auto',
};
const AddAcademicRecord = (props: any) => {
  const classes = useStyles();
  const { userData, handleClose, setAcademicRecordStatus } = props;
  const [study, setStudy] = React.useState('');
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(dayjs()));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(dayjs()));
  const [formData, setFormData] = useState<AcademicRecords>({
    contactId: userData?.applicantId,
    typeOfStudy: '',
    percentage: 0,
    fieldOfStudy: '',
    startDate: '',
    endDate: '',
    institute: '',
    marksheet: '',
  });
  const [fileName, setFileName] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string | null>(null);
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);

  const handleChange = (event: SelectChangeEvent) => {
    setStudy(event.target.value as string);
  };
  const handleChangeStartDate = (newValue: Dayjs | null) => {
    setStartDate(newValue);
    if (newValue && endDate && newValue.isAfter(endDate)) {
      setStartDateError('Start date cannot be after the end date');
    } else {
      setStartDateError(null);
    }
  };

  const handleChangeEndDate = (newValue: Dayjs | null) => {
    setEndDate(newValue);
    if (newValue && startDate && newValue.isBefore(startDate)) {
      setEndDateError('End date cannot be before the start date');
    } else {
      setEndDateError(null);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const splitData = base64String.split(',');
        setBase64Image(splitData[1]);
        console.log('Base64 Image: ', base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    if (name === 'percentage') {
      const regex = /^(100|\d{0,2})$/;
      if (regex.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value === '' ? null : Number(value),
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const formatDate = (value: Dayjs | null): string => {
    if (value === null) {
      return '';
    }
    return value.format('YYYY-MM-DD');
  };
  const postAcademicsRecords = () => {
    const dateValueStart: Dayjs | null = dayjs(startDate);
    const formattedStartDate = formatDate(dateValueStart);

    const dateValueEnd: Dayjs | null = dayjs(endDate);
    const formattedEndDate = formatDate(dateValueEnd);

    const payload: any = {
      ...formData,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      typeOfStudy: study,
      marksheet: base64Image,
      percentage: Number(formData.percentage),
      // issueDate: formattedDate,
    };
    console.log('payload32432', payload);

    postAcademicRecords(payload)
      .then((res) => {
        if (res?.success) {
          enqueueSnackbar({
            message: 'Academic Records Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          handleClose();
          setAcademicRecordStatus(true);
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        handleClose();
        console.error(err);
      });
  };
  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '15px' }}>Add Academic Records</Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid container spacing={2} sx={{ marginTop: '-40px' }}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Name of the institute</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              name="institute"
              value={formData.institute}
              onChange={handleChangeField}
              placeholder="Enter School"
              variant="outlined"
              fullWidth
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Field of study</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              name="fieldOfStudy"
              value={formData.fieldOfStudy}
              onChange={handleChangeField}
              placeholder="Enter field of study"
              variant="outlined"
              fullWidth
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Start Date</Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={startDate}
                  onChange={handleChangeStartDate}
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
              {startDateError && <Typography style={{ color: 'red', fontSize: '12px' }}>{startDateError}</Typography>}
            </Box>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Upload marksheets(optional)</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              variant="outlined"
              fullWidth
              size="small"
              placeholder="Upload Image"
              value={fileName}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton component="label">
                      <input type="file" hidden accept="image/*" onChange={handleFileChange} />
                      <FileUploadOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Type of Study</Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={study}
                placeholder="Select"
                onChange={handleChange}
                size="small"
                sx={{
                  height: '36px',
                  fontSize: '12px',
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'Under Graduate'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Under Graduate
                </MenuItem>
                <MenuItem
                  value={'SSLC'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  SSLC
                </MenuItem>
                <MenuItem
                  value={'HSC'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  HSC
                </MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Percentage</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter percentage"
              name="percentage"
              value={formData.percentage}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>End Date</Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={endDate}
                  onChange={handleChangeEndDate}
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
              {endDateError && <Typography style={{ color: 'red', fontSize: '12px' }}>{endDateError}</Typography>}
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 1,
              borderRadius: '8px',
              width: 100,
              backgroundColor: 'transparent !important',
              color: 'black',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
              '&:active': {
                backgroundColor: 'transparent !important',
              },
              '&:focus': {
                backgroundColor: 'transparent !important',
              },
              '&:focus-visible': {
                backgroundColor: 'transparent !important',
              },
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none' }}
            fullWidth
            onClick={postAcademicsRecords}
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>Save</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddAcademicRecord;
